import { isTruthy } from '@shared';

export interface HcmDepartmentFunction {
  departmentName: string;
  functionName: string;
}
export interface Department {
  id: number;
  jobId: number;
  externalId: string;
  name: string;
  hcmDepartmentFunction: HcmDepartmentFunction;
}

export interface ReferralReportsItem {
  referralId: number;
  candidateId: number;
  jobId: number;
  title: string;
  referredBy: string;
  candidateName: string;
  status: string;
  subStatus: string;
  shortList: boolean;
  offer: boolean;
  hired: boolean;
  reject: boolean;
  stage: string;
  jobDepartments: Department[];
  referralDepartments: Department[];
  createdDate: Date;
}

export class ReferralReportsAdapter {
  constructor(private report: ReferralReportsItem) {}

  get referralId(): number {
    return this.report.referralId;
  }

  get candidateId(): number {
    return this.report.candidateId;
  }

  get jobId(): number {
    return this.report.jobId;
  }

  get title(): string {
    return this.report.title;
  }

  get referredBy(): string {
    return this.report.referredBy;
  }

  get candidateName(): string {
    return this.report.candidateName;
  }

  get status(): string {
    return this.report.status;
  }

  get subStatus(): string {
    return this.report.subStatus;
  }

  get label(): string {
    return !!this.subStatus ? this.subStatus : this.status;
  }

  get shortList(): boolean {
    return this.report.shortList;
  }

  get offer(): boolean {
    return this.report.offer;
  }

  get hired(): boolean {
    return this.report.hired;
  }

  get reject(): boolean {
    return this.report.reject;
  }

  get stage(): string {
    return this.report.stage;
  }

  get jobDepartments(): Department[] {
    return this.report.jobDepartments || [];
  }

  get jobDepartmentName(): string {
    return this.jobDepartments
      .map((department) => department.name)
      .filter(isTruthy)
      .join(',');
  }

  get jobFunctionName(): string {
    return this.jobDepartments
      .filter((department) => !!department.hcmDepartmentFunction)
      .map((department) => department.hcmDepartmentFunction.functionName)
      .filter(isTruthy)
      .join(',');
  }

  get referralDepartments(): Department[] {
    return this.report.referralDepartments || [];
  }

  get referralDepartmentName(): string {
    return this.referralDepartments
      .map((department) => department.name)
      .filter(isTruthy)
      .join(',');
  }

  get referralFunctionName(): string {
    return this.referralDepartments
      .filter((department) => !!department.hcmDepartmentFunction)
      .map((department) => department.hcmDepartmentFunction.functionName)
      .filter(isTruthy)
      .join(',');
  }

  get phaseIcon(): string {
    return this.reject ? 'crying' : this.hired ? 'super-happy' : 'happy';
  }

  get createdDate(): Date {
    return this.report.createdDate;
  }
}
